import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Job } from 'server/shared/models/job';
import { JobRequestCreateInput } from 'server/shared/models/job-request';
import { OrganisationService } from './organisation.service';
import { ToastService } from './toast/toast.service';
@Injectable({
  providedIn: 'root',
})
export class JobRequestService {
  constructor(
    private toastService: ToastService,
    private dialog: MatDialog,
    private router: Router,
    private organisationService: OrganisationService,
  ) {}

  async createJobRequest(jobRequest: JobRequestCreateInput): Promise<Job> {
    return new Promise((resolve, reject) => {
      Meteor.call(
        'createJobRequest',
        jobRequest,
        (error: Meteor.Error, result: any) => {
          // toasts are made in component
          if (error) {
            reject(error);
          } else {
            resolve(result);
          }
        },
      );
    });
  }

  async retractJobRequest(
    jobRequestId: string,
    makeSuccessToast = true,
  ): Promise<Job | string> {
    return new Promise((resolve, reject) => {
      Meteor.call(
        'retractJobRequest',
        jobRequestId,
        (error: Meteor.Error, result: any) => {
          if (error) {
            this.toastService.add({
              type: 'ERROR',
              message: 'jobRequestRetractError',
            });
            reject(error);
          } else {
            if (makeSuccessToast) {
              this.toastService.add({
                type: 'SUCCESS',
                message: 'jobRequestRetracted',
              });
            }
            resolve(result);
          }
        },
      );
    });
  }

  async requestRetractionOnRequest(
    jobRequestId: string,
    makeSuccessToast = true,
  ): Promise<Job | string> {
    return new Promise((resolve, reject) => {
      Meteor.call(
        'requestRetractionOnRequest',
        jobRequestId,
        (error: Meteor.Error, result: any) => {
          if (error) {
            this.toastService.add({
              type: 'ERROR',
              message: 'jobRequestRequestRetractionError',
            });
            reject(error);
          } else {
            if (makeSuccessToast) {
              this.toastService.add({
                type: 'SUCCESS',
                message: 'jobRequestRequestRetraction',
              });
            }
            resolve(result);
          }
        },
      );
    });
  }

  async approveRetractionOnRequest(
    jobRequestId: string,
    makeSuccessToast = true,
  ): Promise<Job | string> {
    return new Promise((resolve, reject) => {
      Meteor.call(
        'approveRetractionOnRequest',
        jobRequestId,
        (error: Meteor.Error, result: any) => {
          if (error) {
            this.toastService.add({
              type: 'ERROR',
              message: 'approveRetractionOnRequestError',
            });
            reject(error);
          } else {
            if (makeSuccessToast) {
              this.toastService.add({
                type: 'SUCCESS',
                message: 'approveRetractionOnRequest',
              });
            }
            resolve(result);
          }
        },
      );
    });
  }

  async rejectRetractionOnRequest(
    jobRequestId: string,
    makeSuccessToast = true,
  ): Promise<Job | string> {
    return new Promise((resolve, reject) => {
      Meteor.call(
        'rejectRetractionOnRequest',
        jobRequestId,
        (error: Meteor.Error, result: any) => {
          if (error) {
            this.toastService.add({
              type: 'ERROR',
              message: 'rejectRetractionOnRequestError',
            });
            reject(error);
          } else {
            if (makeSuccessToast) {
              this.toastService.add({
                type: 'SUCCESS',
                message: 'rejectRetractionOnRequest',
              });
            }
            resolve(result);
          }
        },
      );
    });
  }
  async approveJobRequest(jobRequestId: string): Promise<Job> {
    return new Promise((resolve, reject) => {
      Meteor.call(
        'approveJobRequest',
        jobRequestId,
        (error: Meteor.Error, result: any) => {
          if (error) {
            this.toastService.add({
              type: 'ERROR',
              message: 'serverError',
            });
            reject(error);
          } else {
            this.toastService.add({
              type: 'SUCCESS',
              message: 'jobRequestApproved',
            });
            resolve(result);
          }
        },
      );
    });
  }

  async rejectJobRequest(jobRequestId: string): Promise<Job> {
    return new Promise((resolve, reject) => {
      Meteor.call(
        'rejectJobRequest',
        jobRequestId,
        (error: Meteor.Error, result: any) => {
          if (error) {
            this.toastService.add({
              type: 'ERROR',
              message: 'serverError',
            });
            reject(error);
          } else {
            this.toastService.add({
              type: 'SUCCESS',
              message: 'jobRequestRejected',
            });
            resolve(result);
          }
        },
      );
    });
  }
}
